import { render, staticRenderFns } from "./banner_logo_ppi.vue?vue&type=template&id=0ff7e60e&scoped=true&"
import script from "./banner_logo_ppi.vue?vue&type=script&lang=js&"
export * from "./banner_logo_ppi.vue?vue&type=script&lang=js&"
import style0 from "./banner_logo_ppi.vue?vue&type=style&index=0&id=0ff7e60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff7e60e",
  null
  
)

export default component.exports